// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"53ddc455","164":"61eea1ed","230":"3644babe","460":"18b8e487","560":"41818737","741":"f19a0900","817":"d7c60d09","874":"a4537cba","926":"3efafcfb","931":"bf16e96f"}[chunkId] + ".chunk.js";
};